import { useEffect } from 'react';

import { SESSION_EVENT_CHANNEL } from '../constants';

export const useOnSessionObjectsCleared = (callback: () => void): void => {
  useEffect(() => SESSION_EVENT_CHANNEL.registerOnSessionObjectsCleared(callback), [callback]);
};

export const useOnSessionUpdate = (callback: () => void): void => {
  useEffect(() => SESSION_EVENT_CHANNEL.registerOnTokenChange(callback), [callback]);
};
